export enum TimeBeforeTypeEnum {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
}
